

export default function ChevronDownIcon(
  attributes: React.SVGProps<SVGSVGElement>,
) {
  return (
    <>
      <svg
        width='24'
        height='24'
        fill='none'
        stroke='currentColor'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        {...attributes}
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M19 9l-7 7-7-7'
        />
      </svg>
    </>
  );
}
